import { Segment } from '@calendly/segment'
import { useEffect } from 'react'
import { createRoot } from 'react-dom/client'

import { getAppSettings } from 'common'
import ReactApp from 'components/payment'
import configure from 'configure'
import { createBlockingHistory } from 'core/navigation'
import Settings from 'core/settings'
import createStore from 'create_store'
import initI18n from 'initializers/i18n'
import reducers from 'reducers/payment'
import getBackendData from 'services/backend_data'

import 'landing.sass'

const WrapperApp = ({ children }) => {
  useEffect(() => {
    document.querySelectorAll('a[href^="/app/signup"]').forEach((link) => {
      Segment.trackLink(link, 'signup.click', link.dataSet)
    })

    const navbar = document.querySelector('.navbar')
    if (!navbar) return

    navbar.querySelector('.toggle').addEventListener('click', () => {
      navbar.querySelector('.toggle').classList.toggle('open')
      navbar.querySelector('.links').classList.toggle('open')
    })

    document.addEventListener('scroll', () => {
      if (window.innerWidth > 768 && (window.scrollY > 20)) {
        navbar.classList.add('shadow')
        return
      }
      navbar.classList.remove('shadow')
    })
  }, [])

  return children
}

const BackendData = getBackendData()

document.addEventListener('DOMContentLoaded', async () => {
  const [{ value: [_, appSettings] }] = await Promise.allSettled([await getAppSettings(), await initI18n(BackendData.locale)])
  Settings.set(appSettings)
  configure(BackendData, appSettings)

  const history = createBlockingHistory()
  const store = createStore(reducers, BackendData.modules, history)
  const enabledFeatures = BackendData.enabled_features
  const layers = BackendData.layers
  const isAuthenticated = BackendData.is_authenticated

  createRoot(document.getElementById('root')).render(
    <WrapperApp>
      <ReactApp
        store={store}
        history={history}
        enabledFeatures={enabledFeatures}
        layers={layers}
        isAuthenticated={isAuthenticated}
      />
    </WrapperApp>
  )
})
